// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ga-6";
export var emphasizeQuantity = "_ga-3";
export var flatBottomCorners = "_ga-5";
export var productImage = "_ga-0";
export var quantityContainer = "_ga-2";
export var tooltip = "_ga-1";
export var wrapAndEllipsesOverflow = "_ga-4";